import { React, useState } from "react";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import UpdateVfcRenewal from "./Components/UpdateVfcRenewal";
import AuditVfc from "./Components/AuditVfc";
import ManageAuditRenewal from "./Components/ManageAuditRenewal";
import Meetings from "./Components/Meetings";

const UpdateRenewalandAudit = () => {
  const [key, setKey] = useState("Meetings");

  return (
    <div className="tabs-container">
      <Tabs
        id="controlled-tab-example"
        activeKey={key}
        onSelect={(k) => setKey(k)}
        className="mb-3"
      >
        <Tab eventKey="Meetings" title="Meetings">
          <Meetings />
        </Tab>
        <Tab eventKey="Update VFC & Renewal" title="Update VFC & Renewal">
          <UpdateVfcRenewal />
        </Tab>
        <Tab eventKey="Audit Report" title="Audit Report">
          <AuditVfc />
        </Tab>
        <Tab
          eventKey="Manage Report and Renewal"
          title="Manage Report and Renewal"
        >
          <ManageAuditRenewal />
        </Tab>
      </Tabs>
    </div>
  );
};

export default UpdateRenewalandAudit;
